import React, { Component } from 'react';
import style from './AppTour.module.css';

import Lottie from 'lottie-react';
import student_animation from '../../lottieAnimations/student_animation.json';
import schedule_animation from '../../lottieAnimations/schedule_animation.json';
import studying_animation from '../../lottieAnimations/studying_animation.json';
import profile_animation from '../../lottieAnimations/profile_animation.json';
import classroom_animation from '../../lottieAnimations/classroom_animation.json';
import notifications_animation from '../../lottieAnimations/notifications_animation.json';
import checkmark from '../../lottieAnimations/checkmark.json';
import icons from '../../icons';

import { Swiper, SwiperSlide } from 'swiper/react';


const checkIOS = () => {
    if (navigator.standalone) {
        return false;
    }

    const ua = window.navigator.userAgent;
    const webkit = !!ua.match(/WebKit/i);
    const isIPad = !!ua.match(/iPad/i);
    const isIPhone = !!ua.match(/iPhone/i)
    const isIOS = isIPad || isIPhone;
    const isSafari = isIOS && webkit && !ua.match(/CriOS/i);

    return isIOS && isSafari;
};

export default class AppTour extends Component {
    constructor(props) {
        super(props);

        this.state = {
            activeSlide: 0,
        }
        
        this._currentPage = 0;

        this.handlePagination = event => {
            let elements = Array.from(document.querySelectorAll(`.${style.paginationUnselected}`));
            document.querySelectorAll(`.${style.paginationSelected}`).forEach(element => element.classList.remove(style.paginationSelected));
            event.target.classList.add(style.paginationSelected);
            try {
                let pageToSlide = elements.indexOf(event.target);
                Array.from(document.querySelector("#welcome-pages").children)[pageToSlide].scrollIntoView({ block: 'start',  behavior: 'smooth' });
            } catch (err) {
                console.log(err);
            }
        };
    };

    componentDidMount() {
        /*let elements = Array.from(document.querySelector("#welcome-pages").children)
        Array.from(document.querySelector("#welcome-pages").children).forEach(element => {
            // define an observer instance
            let observer = new IntersectionObserver(onIntersection, {
                root: null,   // default is the viewport
                threshold: .5 // percentage of taregt's visible area. Triggers "onIntersection"
            })
            
            // callback is called on intersection change
            let component = this;
            function onIntersection(entries, opts){
                entries.forEach(entry => { 
                    if (entry.isIntersecting) {
                        let index = elements.indexOf(entry.target);
                        console.log(component._currentPage, index);
                        if (component._currentPage + 1 === index) {
                            // stop scroll
                            component._currentPage += 1;
                        }
                        if (component._currentPage - 1 === index) {
                            // stop scroll
                            component._currentPage -= 1;
                        }
                        Array.from(document.querySelectorAll(`.${style.paginationUnselected}`)).forEach(element => element.classList.remove(style.paginationSelected));
                        Array.from(document.querySelectorAll(`.${style.paginationUnselected}`))[index].classList.add(style.paginationSelected);
                        console.log(entry);
                        entry.target.scrollIntoView({ block: 'start',  behavior: 'smooth' });
                    }
                });
            }
            
            observer.observe(element);
        });*/
    }

    render() {
        return (
            <main className={ style.main }>
                { localStorage.getItem("appTourDone") ?
                    <div style={{ display: "flex" }}>
                        <div className={ style.page }>
                            <h1>UPDATE TOUR FIRST PAGE</h1>
                        </div>
                        <div className={ style.page }>
                            <h1>UPDATE TOUR SECOND PAGE</h1>
                        </div>
                    </div> :
                    <>
                        { /* -webkit-overflow-scrolling: auto */ }
                        {/* <div className={ style.scrollContainer } id="welcome-pages" style={{ display: "flex", WebkitOverflowScrolling: "auto", scrollSnapStop: "always" }}>
                            <div className={ style.page }>
                                <h1 className={ style.title }>School<span>Diary</span></h1>
                                <Lottie 
                                    style={{ backgroundColor: "rgb(44, 44, 44)" }}
                                    options={{
                                        loop: true,
                                        autoplay: true,
                                        animationData: student_animation,
                                        rendererSettings: {
                                            preserveAspectRatio: "xMidYMid slice"
                                        }
                                        }}
                                    height={ 300 }
                                    width={ 300 }
                                />
                                <h2 className={ style.generalDetails }>
                                    <span style={{ color: "var(--orange)" }}>Benvenuto!</span> SchoolDiary è un'applicazione ideata come diario scolastico condiviso con tutta la tua classe. 
                                    <br></br>
                                    <br></br>
                                    Puoi segnare qui tutti i compiti per casa, le verifiche e le interrogazioni assegnati
                                    e tutti i tuoi compagni di classe li potranno vedere.
                                </h2>
                            </div>
                            <div className={ style.page }>
                                <h1 className={ style.title }><span>Orario</span></h1>
                                <Lottie 
                                    style={{ backgroundColor: "rgb(44, 44, 44)" }}
                                    options={{
                                        loop: true,
                                        autoplay: true,
                                        animationData: schedule_animation,
                                        }}
                                    height={ 300 }
                                    width={ 300 }
                                />
                                <h2 className={ style.generalDetails }>
                                    Per prima cosa, imposta l'orario definitivo della tua classe cliccando sul tasto
                                    <br></br>
                                    <br></br>
                                    <a href="/schedule" className={ style.toTimetable }>ORARIO</a>
                                    <br></br>
                                    Per ogni ora dovrai indicare la materia, l'ora di inizio e quella di fine, ed
                                    eventuali dettagli.

                                </h2>
                            </div>
                            <div className={ style.page }>
                                <h1 className={ style.title }><span>Eventi</span></h1>
                                <Lottie 
                                    style={{ backgroundColor: "rgb(44, 44, 44)" }}
                                    options={{
                                        loop: true,
                                        autoplay: true,
                                        animationData: studying_animation,
                                        }}
                                    height={ 300 }
                                    width={ 300 }
                                />
                                <h2 className={ style.generalDetails }>
                                    Premi sul tasto "Nuovo evento" per aggiungere un compito per casa, una verifica, o un'interrogazione che sarà visibile 
                                    a tutti i tuoi compagni di classe.
                                </h2>
                                <div className={ style.addEvent } >
                                    <img alt="add icon" src={ icons.add_icon } />
                                    <h3>NUOVO EVENTO</h3>
                                </div>
                                <h2 className={ style.generalDetails }>
                                    L'evento sarà ora visibile sulla pagina del calendario. Se si tratta di un compito per casa o di un'interrogazione,
                                    puoi segnarlo come svolto spuntando la casella a fianco
                                </h2>
                            </div>
                            <div className={ style.page }>
                                <h1 className={ style.title }><span>Impostazioni</span></h1>
                                <Lottie 
                                    style={{ backgroundColor: "rgb(44, 44, 44)", marginTop: "1rem", marginBottom: "2rem" }}
                                    options={{
                                        loop: true,
                                        autoplay: true,
                                        animationData: profile_animation,
                                        }}
                                    height={ 300 }
                                    width={ 300 }
                                />
                                <h2 className={ style.generalDetails }>
                                    Premi sul tasto "Impostazioni" per modificare le impostazioni del tuo profilo e decidere quali notifiche vuoi ricevere.
                                </h2>
                                <div className={ style.btnToCalendar } onClick={ () => window.location.href = "/settings" } >
                                    <img alt="settings icon" src={ icons.settings_icon } />
                                    <h3>IMPOSTAZIONI</h3>
                                </div> 
                                <h2 className={ style.generalDetails } style={{ color: "red" }}>
                                    L'applicazione è ancora in beta e potrebbero esserci bug e malfunzionamenti. Se qualcosa non funziona come dovrebbe,
                                    segnalalo dalla pagina delle impostazioni.
                                </h2>
                            </div>
                            <div className={ style.page }>
                                <h1 className={ style.title }><span>È tutto!</span></h1>
                                <Lottie 
                                    style={{ backgroundColor: "rgb(44, 44, 44)", marginTop: "2rem", marginBottom: "2rem" }}
                                    options={{
                                        loop: true,
                                        speed: 0.25,
                                        autoplay: true,
                                        animationData: checkmark,
                                        }}
                                    height={ 300 }
                                    width={ 300 }
                                />
                                <div onClick={ () => {
                                    localStorage.setItem("appTourDone", true);
                                    window.location.href = "/";
                                } } className={ style.addEvent } >
                                    <img alt="add icon" src={ icons.home_icon } />
                                    <h3>VAI ALLA HOME</h3>
                                </div>
                            </div>
                        </div>
                        <div className={ style.pagination }>
                            <span className={ [style.paginationUnselected, style.paginationSelected].join(" ") } onClick={ this.handlePagination }></span>
                            <span className={ style.paginationUnselected } onClick={ this.handlePagination }></span>
                            <span className={ style.paginationUnselected } onClick={ this.handlePagination }></span>
                            <span className={ style.paginationUnselected } onClick={ this.handlePagination }></span>
                            <span className={ style.paginationUnselected } onClick={ this.handlePagination }></span>
                        </div> */}
                        <Swiper direction="horizontal" onSwiper={ swiper => this.setState({ swiper }) } onSlideChange={ ({ activeIndex }) => {
                            this.setState({ activeSlide: activeIndex });
                        } }>
                            <SwiperSlide className={ style.page }>
                                <h1 className={ style.title }>School<span>Diary</span></h1>
                                <Lottie 
                                    style={{ backgroundColor: "rgb(44, 44, 44)" }}
                                    loop={ true }
                                    autoplay={ true }
                                    animationData={ student_animation }
                                    rendererSettings={{
                                        preserveAspectRatio: "xMidYMid slice"
                                    }}
                                    height={ 300 }
                                    width={ 300 }
                                />
                                <h2 className={ style.generalDetails }>
                                    <span style={{ color: "var(--orange)" }}>Benvenuto!</span> SchoolDiary è un'applicazione ideata come diario scolastico condiviso con tutta la tua classe. 
                                    <br></br>
                                    <br></br>
                                    Puoi segnare qui tutti i compiti per casa, le verifiche e le interrogazioni assegnati
                                    e tutti i tuoi compagni di classe li potranno vedere.
                                </h2>
                            </SwiperSlide>
                            <SwiperSlide className={ style.page }>
                                <h1 className={ style.title }><span>Orario</span></h1>
                                <Lottie 
                                    style={{ backgroundColor: "rgb(44, 44, 44)" }}
                                    loop={ true }
                                    autoplay={ true }
                                    animationData={ schedule_animation }
                                    height={ 300 }
                                    width={ 300 }
                                />
                                <h2 className={ style.generalDetails }>
                                    Per prima cosa, imposta le materie e l'orario della tua classe dalla sezione Menu
                                    <br></br>
                                    <br></br>
                                    <div style={{ display: "grid", justifyContent: "center" }}>
                                        <nav className={ style.nav }>
                                            <svg width="24px" height="24px" viewBox="0 0 21 18">
                                                <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                                    <g id="Rounded" transform="translate(-136.000000, -4145.000000)">
                                                        <g id="Social" transform="translate(100.000000, 4044.000000)">
                                                            <g id="-Round-/-Social-/-school" transform="translate(34.000000, 98.000000)">
                                                                <g>
                                                                    <polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
                                                                    <path d="M5,13.18 L5,15.99 C5,16.72 5.4,17.4 6.04,17.75 L11.04,20.48 C11.64,20.81 12.36,20.81 12.96,20.48 L17.96,17.75 C18.6,17.4 19,16.72 19,15.99 L19,13.18 L12.96,16.48 C12.36,16.81 11.64,16.81 11.04,16.48 L5,13.18 Z M11.04,3.52 L2.61,8.12 C1.92,8.5 1.92,9.5 2.61,9.88 L11.04,14.48 C11.64,14.81 12.36,14.81 12.96,14.48 L21,10.09 L21,16 C21,16.55 21.45,17 22,17 C22.55,17 23,16.55 23,16 L23,9.59 C23,9.22 22.8,8.89 22.48,8.71 L12.96,3.52 C12.36,3.2 11.64,3.2 11.04,3.52 Z" id="🔹-Icon-Color" fill="white"></path>
                                                                </g>
                                                            </g>
                                                        </g>
                                                    </g>
                                                </g>
                                            </svg>
                                            <svg height="24px" viewBox="0 0 24 24" width="24px" style={{ fill:  "white" }}>
                                                <path d="M0 0h24v24H0z" fill="none"/>
                                                <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/>
                                            </svg>
                                            <svg height="24px" viewBox="0 0 24 24" width="24px" fill="#d86c07">
                                                <path d="M0 0h24v24H0z" fill="none"/>
                                                <path d="M3 5v14c0 1.1.89 2 2 2h6V3H5c-1.11 0-2 .9-2 2zm16-2h-6v8h8V5c0-1.1-.9-2-2-2zm-6 18h6c1.1 0 2-.9 2-2v-6h-8v8z"/>
                                            </svg>
                                            {/* <img src={ icons.settings_icon } ></img> */}
                                        </nav>
                                    </div>
                                    <br></br>
                                    Per ogni ora dovrai indicare la materia, l'ora di inizio e quella di fine.

                                </h2>
                            </SwiperSlide>
                            <SwiperSlide className={ style.page }>
                                <h1 className={ style.title }><span>Eventi</span></h1>
                                <Lottie 
                                    style={{ backgroundColor: "rgb(44, 44, 44)" }}
                                    loop={ true }
                                    autoplay={ true }
                                    animationData={ studying_animation }
                                    height={ 300 }
                                    width={ 300 }
                                />
                                <h2 className={ style.generalDetails }>
                                    Premi sul tasto "+" per aggiungere un compito per casa, una verifica, o un'interrogazione che sarà visibile 
                                    a tutti i tuoi compagni di classe.
                                </h2>
                                <div style={{ display: "grid", justifyContent: "center" }}>
                                    <nav className={ style.nav }>
                                        <svg width="24px" height="24px" viewBox="0 0 21 18">
                                            <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                                <g id="Rounded" transform="translate(-136.000000, -4145.000000)">
                                                    <g id="Social" transform="translate(100.000000, 4044.000000)">
                                                        <g id="-Round-/-Social-/-school" transform="translate(34.000000, 98.000000)">
                                                            <g>
                                                                <polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
                                                                <path d="M5,13.18 L5,15.99 C5,16.72 5.4,17.4 6.04,17.75 L11.04,20.48 C11.64,20.81 12.36,20.81 12.96,20.48 L17.96,17.75 C18.6,17.4 19,16.72 19,15.99 L19,13.18 L12.96,16.48 C12.36,16.81 11.64,16.81 11.04,16.48 L5,13.18 Z M11.04,3.52 L2.61,8.12 C1.92,8.5 1.92,9.5 2.61,9.88 L11.04,14.48 C11.64,14.81 12.36,14.81 12.96,14.48 L21,10.09 L21,16 C21,16.55 21.45,17 22,17 C22.55,17 23,16.55 23,16 L23,9.59 C23,9.22 22.8,8.89 22.48,8.71 L12.96,3.52 C12.36,3.2 11.64,3.2 11.04,3.52 Z" id="🔹-Icon-Color" fill="white"></path>
                                                            </g>
                                                        </g>
                                                    </g>
                                                </g>
                                            </g>
                                        </svg>
                                        <svg height="24px" viewBox="0 0 24 24" width="24px" style={{ fill: "#d86c07" }}>
                                            <path d="M0 0h24v24H0z" fill="none"/>
                                            <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/>
                                        </svg>
                                        <svg height="24px" viewBox="0 0 24 24" width="24px" fill="#fff">
                                            <path d="M0 0h24v24H0z" fill="none"/>
                                            <path d="M3 5v14c0 1.1.89 2 2 2h6V3H5c-1.11 0-2 .9-2 2zm16-2h-6v8h8V5c0-1.1-.9-2-2-2zm-6 18h6c1.1 0 2-.9 2-2v-6h-8v8z"/>
                                        </svg>
                                        {/* <img src={ icons.settings_icon } ></img> */}
                                    </nav>
                                </div>
                                {/* <div className={ style.addEvent } >
                                    <img alt="" src={ icons.add_icon } />
                                    <h3>NUOVO EVENTO</h3>
                                </div> */}
                                <h2 className={ style.generalDetails }>
                                    L'evento sarà ora visibile a tutti. Se si tratta di un compito per casa o di un'interrogazione,
                                    puoi segnarlo come svolto spuntando la casella a fianco
                                </h2>
                            </SwiperSlide>
                            { !checkIOS() && <SwiperSlide className={ style.page }>
                                <h1 className={ style.title }><span>Notifiche</span></h1>
                                <Lottie 
                                    style={{ backgroundColor: "rgb(44, 44, 44)", marginTop: "1rem", marginBottom: "2rem" }}                                    
                                    loop={ true }
                                    autoplay={ true }
                                    animationData={ notifications_animation }
                                    height={ 300 }
                                    width={ 300 }
                                />
                                <h2 className={ style.generalDetails }>
                                    Dalla pagina "Menu", nella sezione "Notifiche", puoi specificare le tue preferenze sulle notifiche da ricevere
                                </h2>
                                <div style={{ display: "grid", justifyContent: "center" }}>
                                    <nav className={ style.nav }>
                                        <svg width="24px" height="24px" viewBox="0 0 21 18">
                                            <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                                <g id="Rounded" transform="translate(-136.000000, -4145.000000)">
                                                    <g id="Social" transform="translate(100.000000, 4044.000000)">
                                                        <g id="-Round-/-Social-/-school" transform="translate(34.000000, 98.000000)">
                                                            <g>
                                                                <polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
                                                                <path d="M5,13.18 L5,15.99 C5,16.72 5.4,17.4 6.04,17.75 L11.04,20.48 C11.64,20.81 12.36,20.81 12.96,20.48 L17.96,17.75 C18.6,17.4 19,16.72 19,15.99 L19,13.18 L12.96,16.48 C12.36,16.81 11.64,16.81 11.04,16.48 L5,13.18 Z M11.04,3.52 L2.61,8.12 C1.92,8.5 1.92,9.5 2.61,9.88 L11.04,14.48 C11.64,14.81 12.36,14.81 12.96,14.48 L21,10.09 L21,16 C21,16.55 21.45,17 22,17 C22.55,17 23,16.55 23,16 L23,9.59 C23,9.22 22.8,8.89 22.48,8.71 L12.96,3.52 C12.36,3.2 11.64,3.2 11.04,3.52 Z" id="🔹-Icon-Color" fill="white"></path>
                                                            </g>
                                                        </g>
                                                    </g>
                                                </g>
                                            </g>
                                        </svg>
                                        <svg height="24px" viewBox="0 0 24 24" width="24px" style={{ fill:  "white" }}>
                                            <path d="M0 0h24v24H0z" fill="none"/>
                                            <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/>
                                        </svg>
                                        <svg height="24px" viewBox="0 0 24 24" width="24px" fill="#d86c07">
                                            <path d="M0 0h24v24H0z" fill="none"/>
                                            <path d="M3 5v14c0 1.1.89 2 2 2h6V3H5c-1.11 0-2 .9-2 2zm16-2h-6v8h8V5c0-1.1-.9-2-2-2zm-6 18h6c1.1 0 2-.9 2-2v-6h-8v8z"/>
                                        </svg>
                                        {/* <img src={ icons.settings_icon } ></img> */}
                                    </nav>
                                </div>
                            </SwiperSlide>}
                            <SwiperSlide className={ style.page }>
                                <h1 className={ style.title }><span>Classroom</span></h1>
                                <Lottie 
                                    style={{ backgroundColor: "rgb(44, 44, 44)" }}
                                    loop={ true }
                                    autoplay={ true }
                                    animationData={ classroom_animation }
                                    height={ 300 }
                                    width={ 300 }
                                />
                                <h2 className={ style.generalDetails }>
                                    Dal menu, vai nella sezione "Classroom" per collegare il tuo account Google a SchoolDiary e attivare la sincronizzazione
                                    degli eventi da Google Classroom. 
                                </h2>
                                <h2 className={ style.generalDetails }>
                                    Ogni volta che aprirai SchoolDiary, i tuoi eventi su Google Classroom verranno automaticamente aggiunti.
                                </h2>
                                <div style={{ display: "grid", justifyContent: "center" }}>
                                    <nav className={ style.nav }>
                                        <svg width="24px" height="24px" viewBox="0 0 21 18">
                                            <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                                <g id="Rounded" transform="translate(-136.000000, -4145.000000)">
                                                    <g id="Social" transform="translate(100.000000, 4044.000000)">
                                                        <g id="-Round-/-Social-/-school" transform="translate(34.000000, 98.000000)">
                                                            <g>
                                                                <polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
                                                                <path d="M5,13.18 L5,15.99 C5,16.72 5.4,17.4 6.04,17.75 L11.04,20.48 C11.64,20.81 12.36,20.81 12.96,20.48 L17.96,17.75 C18.6,17.4 19,16.72 19,15.99 L19,13.18 L12.96,16.48 C12.36,16.81 11.64,16.81 11.04,16.48 L5,13.18 Z M11.04,3.52 L2.61,8.12 C1.92,8.5 1.92,9.5 2.61,9.88 L11.04,14.48 C11.64,14.81 12.36,14.81 12.96,14.48 L21,10.09 L21,16 C21,16.55 21.45,17 22,17 C22.55,17 23,16.55 23,16 L23,9.59 C23,9.22 22.8,8.89 22.48,8.71 L12.96,3.52 C12.36,3.2 11.64,3.2 11.04,3.52 Z" id="🔹-Icon-Color" fill="white"></path>
                                                            </g>
                                                        </g>
                                                    </g>
                                                </g>
                                            </g>
                                        </svg>
                                        <svg height="24px" viewBox="0 0 24 24" width="24px" style={{ fill:  "white" }}>
                                            <path d="M0 0h24v24H0z" fill="none"/>
                                            <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/>
                                        </svg>
                                        <svg height="24px" viewBox="0 0 24 24" width="24px" fill="#d86c07">
                                            <path d="M0 0h24v24H0z" fill="none"/>
                                            <path d="M3 5v14c0 1.1.89 2 2 2h6V3H5c-1.11 0-2 .9-2 2zm16-2h-6v8h8V5c0-1.1-.9-2-2-2zm-6 18h6c1.1 0 2-.9 2-2v-6h-8v8z"/>
                                        </svg>
                                        {/* <img src={ icons.settings_icon } ></img> */}
                                    </nav>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide className={ style.page }>
                                <h1 className={ style.title }><span>Menu</span></h1>
                                <Lottie 
                                    style={{ backgroundColor: "rgb(44, 44, 44)", marginTop: "1rem", marginBottom: "2rem" }}
                                    
                                    loop={ true }
                                    autoplay={ true }
                                    animationData={ profile_animation }
                                    height={ 300 }
                                    width={ 300 }
                                />
                                <h2 className={ style.generalDetails }>
                                    Vai nella pagina del Menu per modificare le impostazioni del tuo profilo e scoprire tutte le funzionalità di SchoolDiary.
                                </h2>
                                <div style={{ display: "grid", justifyContent: "center" }}>
                                    <nav className={ style.nav }>
                                        <svg width="24px" height="24px" viewBox="0 0 21 18">
                                            <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                                <g id="Rounded" transform="translate(-136.000000, -4145.000000)">
                                                    <g id="Social" transform="translate(100.000000, 4044.000000)">
                                                        <g id="-Round-/-Social-/-school" transform="translate(34.000000, 98.000000)">
                                                            <g>
                                                                <polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
                                                                <path d="M5,13.18 L5,15.99 C5,16.72 5.4,17.4 6.04,17.75 L11.04,20.48 C11.64,20.81 12.36,20.81 12.96,20.48 L17.96,17.75 C18.6,17.4 19,16.72 19,15.99 L19,13.18 L12.96,16.48 C12.36,16.81 11.64,16.81 11.04,16.48 L5,13.18 Z M11.04,3.52 L2.61,8.12 C1.92,8.5 1.92,9.5 2.61,9.88 L11.04,14.48 C11.64,14.81 12.36,14.81 12.96,14.48 L21,10.09 L21,16 C21,16.55 21.45,17 22,17 C22.55,17 23,16.55 23,16 L23,9.59 C23,9.22 22.8,8.89 22.48,8.71 L12.96,3.52 C12.36,3.2 11.64,3.2 11.04,3.52 Z" id="🔹-Icon-Color" fill="white"></path>
                                                            </g>
                                                        </g>
                                                    </g>
                                                </g>
                                            </g>
                                        </svg>
                                        <svg height="24px" viewBox="0 0 24 24" width="24px" style={{ fill:  "white" }}>
                                            <path d="M0 0h24v24H0z" fill="none"/>
                                            <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/>
                                        </svg>
                                        <svg height="24px" viewBox="0 0 24 24" width="24px" fill="#d86c07">
                                            <path d="M0 0h24v24H0z" fill="none"/>
                                            <path d="M3 5v14c0 1.1.89 2 2 2h6V3H5c-1.11 0-2 .9-2 2zm16-2h-6v8h8V5c0-1.1-.9-2-2-2zm-6 18h6c1.1 0 2-.9 2-2v-6h-8v8z"/>
                                        </svg>
                                        {/* <img src={ icons.settings_icon } ></img> */}
                                    </nav>
                                </div>
                                <h2 className={ style.generalDetails } style={{ color: "red" }}>
                                    L'applicazione è ancora in beta e potrebbero esserci bug e malfunzionamenti. Se qualcosa non funziona come dovrebbe,
                                    segnalalo dall'apposita sezione dell'app.
                                </h2>
                            </SwiperSlide>
                            <SwiperSlide className={ style.page }>
                                <h1 className={ style.title }><span>È tutto!</span></h1>
                                <Lottie 
                                    style={{ backgroundColor: "rgb(44, 44, 44)", marginTop: "2rem", marginBottom: "2rem" }}
                                    loop={ true }
                                    autoplay={ true }
                                    animationData={ checkmark }
                                    speed={ 0.25 }
                                    height={ 300 }
                                    width={ 300 }
                                />
                                <div onClick={ () => {
                                    localStorage.setItem("appTourDone", true);
                                    window.location.href = "/";
                                } } className={ style.addEvent } >
                                    <img alt="" src={ icons.home_icon } />
                                    <h3>VAI ALLA HOME</h3>
                                </div>
                            </SwiperSlide>
                        </Swiper>
                        <div className={ [style.pagination, checkIOS() && style.apple].join(" ") }>
                            <span style={{ left: !checkIOS() && "calc((100vw / 2) - 3.75rem);" }} className={ this.state.activeSlide === 0 ? [style.paginationUnselected, style.paginationSelected].join(" ") : style.paginationUnselected } onClick={ () => this.state.swiper.slideTo(0) }></span>
                            <span className={ this.state.activeSlide === 1 ? [style.paginationUnselected, style.paginationSelected].join(" ") : style.paginationUnselected } onClick={ () => this.state.swiper.slideTo(1) }></span>
                            <span className={ this.state.activeSlide === 2 ? [style.paginationUnselected, style.paginationSelected].join(" ") : style.paginationUnselected } onClick={ () => this.state.swiper.slideTo(2) }></span>
                            <span className={ this.state.activeSlide === 3 ? [style.paginationUnselected, style.paginationSelected].join(" ") : style.paginationUnselected } onClick={ () => this.state.swiper.slideTo(3) }></span>
                            <span className={ this.state.activeSlide === 4 ? [style.paginationUnselected, style.paginationSelected].join(" ") : style.paginationUnselected } onClick={ () => this.state.swiper.slideTo(4) }></span>
                            <span className={ this.state.activeSlide === 5 ? [style.paginationUnselected, style.paginationSelected].join(" ") : style.paginationUnselected } onClick={ () => this.state.swiper.slideTo(5) }></span>
                            { !checkIOS() && <span className={ this.state.activeSlide === 6 ? [style.paginationUnselected, style.paginationSelected].join(" ") : style.paginationUnselected } onClick={ () => this.state.swiper.slideTo(6) }></span>}
                        </div>
                    </>
                }
            </main>
        );
    };
};
